import { MethodTypesEnum } from '@common/enums';

export const methodTypes = new Map<MethodTypesEnum, string>([
  [MethodTypesEnum.BankCard, 'Карта'],
  [MethodTypesEnum.BankAccount, 'Банковский счёт'],
]);
